// ============================================
// 2026-10-04：大屏叠加编辑 —— 视口投放坐标换算（纯函数，便于单测）
// 2026-10-05：组件层级统一移到右侧 2D 图层面板（LayerPanel2D），原左侧图层树 helpers 已移除
// ============================================
import { clampPosition } from './overlayEdit';

/**
 * 拖拽投放坐标换算——视口 client 坐标 → 页面坐标（组件中心对齐落点，钳制在页面内）。
 * rect 为编辑层页面容器（pageRef）的 getBoundingClientRect。
 */
export function dropPagePosition(
  clientX: number,
  clientY: number,
  rect: { left: number; top: number },
  scale: { x: number; y: number },
  anchorScale: number,
  size: { width: number; height: number },
  page: { width: number; height: number },
): { x: number; y: number } {
  const kx = (scale.x || 1) * (anchorScale || 1);
  const ky = (scale.y || 1) * (anchorScale || 1);
  const x = (clientX - rect.left) / kx - size.width / 2;
  const y = (clientY - rect.top) / ky - size.height / 2;
  return clampPosition(x, y, size, page);
}
